export default function Intro() {
  return (
    <div className="relative py-24 sm:py-32">
      <div className="px-6 mx-auto text-white max-w-7xl lg:px-8">
        <div className="flex flex-col items-center justify-center max-w-3xl mx-auto sm:text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-5xl">Returning the Data to the owner</h2>
          <div className="max-w-xl mt-10 text-lg leading-8">
            We envision a future where individuals have full control over their personal data, and businesses can securely access and utilize data in a decentralized and transparent manner.
          </div>
		  <a href="/nodes">
          <div  className="hover:translate-y-[-10px] transition-transform duration-700 ease-in-out cursor-pointer mt-16 bg-gradient-to-r from-[#1A61ED] to-[#11BAE3] text-white sm:text-lg text-sm rounded-md py-3 px-8 font-semibold">
            APPLY FOR NODE
          </div>
		  </a>
        </div>
      </div>
    </div>
  )
}
